<template>
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger>
        <SvgIcon :name="iconName" class="cursor-pointer text-xl" @click="handleClick"></SvgIcon>
      </TooltipTrigger>
      <TooltipContent :side="side"> {{ info }} </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>
<script setup lang="ts">
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '~/components/ui/tooltip';
const SIDE_OPTIONS = ['top', 'bottom', 'left', 'right'] as const;
type Side = (typeof SIDE_OPTIONS)[number];

defineProps({
  iconName: {
    type: String,
    default: 'info',
  },
  info: {
    type: String,
    default: '提示',
  },
  side: {
    type: String as () => Side,
    default: 'top',
  },
});
const emit = defineEmits(['handleClick']);
const handleClick = () => {
  emit('handleClick');
};
</script>
